export default __webpack_public_path__ + "static/media/paste-grid6.1.5998b07e.png";